import 'regenerator-runtime/runtime'
import useBSSLogger from '../hooks/useBSSLogger';
import getapiclient, { getwpclient } from '../lib/ajaxhelper';

const {logger} = useBSSLogger();

const confirmPayment = async (datiCarrello) => {
    const {esito} = await getapiclient().post(`payments/paypalconfirm`, {
        jsonobject: JSON.stringify(datiCarrello)
    })

    logger.debug("conferma pagamento paypal andato a buon fine?", esito);

    return esito
}


export {confirmPayment}